<div class="forgot-password-container">
  <mat-card class="forgot-password-card">
    <mat-card-header>
      <img src="assets/images/logo_full_900.png" alt="Logo" />
    </mat-card-header>
    <mat-card-content style="width:100%;">
      @if(!submitted) {
        <form>
          <div class="form-row">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Email</mat-label>
              <input matInput type="email" required [(ngModel)]="email" [ngModelOptions]="{standalone: true}">
              <mat-icon matPrefix>email</mat-icon>
            </mat-form-field>      
          </div>
          <div class="center">
            <button mat-flat-button class="metallic-text-btn-blue" (click)="submit()">
              Request Password Reset
              <mat-icon>key</mat-icon>
            </button>
          </div>
        </form> 
      } @else if (submitted && loading) {
        <div style="display: flex; justify-content: center; align-items: center;">
          <app-loader></app-loader>
        </div>
      } @else if (submitted && success && !loading) {
        <app-success-error [success]="true"></app-success-error>
        <div class="center">
          An email has been sent with a link to reset your password.
        </div>
      } @else if (submitted && !success && !loading) {
        <app-success-error [success]="false"></app-success-error>
        <div class="center">
          <p>Something went wrong trying to generate a link to reset your password.</p>
          <p>Are you sure you have an account with us?</p>
          <button mat-flat-button class="metallic-text-btn-blue" routerLink="/signup">
            <mat-icon>person_add</mat-icon>
            Create Account
          </button>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>